
import { defineComponent, PropType, computed } from "vue";
import { CollectionProps } from "../../../composables/types";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "CollectionCard",
  props: {
    collection: Object as PropType<CollectionProps>,
    totalGalleries: Number,
  },
  setup(props) {
    const router = useRouter();

    const slug = computed(
      () => `/collection/${props.collection?.collectionTag}`
    );

    const pushToGallery = () => {
      router.push({ path: slug.value });
    };

    const galleryTitle = computed(() =>
      props.totalGalleries === 1 ? "Gallery" : "Galleries"
    );

    return {
      pushToGallery,
      slug,
      galleryTitle,
    };
  },
});
